import React, { FC, useMemo } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { CategoryFilterData, DEFAULT_FILTER } from '../../BrandsList.controller';
import { SkeletonGroup, SkeletonText } from '@shared/components/Skeleton';
import { pxToRem } from '@withjoy/joykit/theme';
import { range } from 'lodash-es';
import { StyledFilterChip, styles } from './CategoryFilter.styles';

interface CategoryFilterProps {
  label: string;
  categories?: CategoryFilterData[];
  selectedItem: CategoryFilterData;
  handleSelect: (item: CategoryFilterData) => void;
}

export const CategoryFilter: FC<CategoryFilterProps> = props => {
  const { label, categories, selectedItem, handleSelect } = props;

  const formattedCategories = useMemo(() => {
    if (categories && categories.length > 0) {
      return [DEFAULT_FILTER, ...categories];
    }
    return [];
  }, [categories]);

  return (
    <Flex
      flexDirection="row"
      alignItems={!!formattedCategories.length ? 'baseline' : 'center'}
      columnGap={3}
      paddingBottom={8}
    >
      <TextV2
        typographyVariant="hed3"
        whiteSpace="nowrap"
      >
        {label}
      </TextV2>
      <SkeletonGroup
        isReady={!!formattedCategories.length}
        placeholder={
          <Flex
            flexDirection="row"
            flexWrap="wrap"
            columnGap={3}
            rowGap={3}
          >
            {range(0, 8).map((_, idx) => (
              <SkeletonText
                key={idx}
                rows={1}
                width={pxToRem(100)}
                skeletonHeight={pxToRem(32)}
              />
            ))}
          </Flex>
        }
      >
        <Flex
          flexDirection="row"
          flexWrap="wrap"
          columnGap={3}
          rowGap={3}
        >
          {formattedCategories.map(category => (
            <StyledFilterChip
              key={category.id}
              __css={styles.filterChip(category.id === selectedItem.id)}
              onClick={() => handleSelect(category)}
            >
              <TextV2 typographyVariant="button1">{category.title}</TextV2>
            </StyledFilterChip>
          ))}
        </Flex>
      </SkeletonGroup>
    </Flex>
  );
};
